import { SET_STARTED, SET_OPTIONS, SET_OPTION, SET_CLUES, SET_COLOR_SET } from './actions';
import { SET_BLOCK, SET_OVER, SET_TURN } from './actions';
import { SELECT_SIZE, UPDATE_STATS, SET_MODE, SET_SKILL, SELECT_TILE, SET_SCORE } from './actions';
import { MODE_SOLO, MODE_AI } from '../../HOME/const';
import _ from 'lodash';
import { OPTIONS_KEY } from '../const';
import { dbset, dbdel } from '../../HOME/utils';
import * as f from '../logic';

export default (state = {}, action) => {
  switch (action.type) {
    case SET_MODE:
      return { ...state, mode: action.mode };
    case SET_SKILL:
      return { ...state, skill: action.skill };
    case SET_CLUES:
      return { ...state, clues: action.clues };
    case SELECT_SIZE:
      return { ...state, size: action.size };
    case UPDATE_STATS:
      return onUpdateStats(state, action.stats);
    case SET_BLOCK:
      return { ...state, blocked: action.blocked };
    case SET_OVER:
      return { ...state, over: action.over };
    case SELECT_TILE:
      return { ...state, selected: action.selected };
    case SET_SCORE:
      return { ...state, score: action.score };
    case SET_TURN:
      return { ...state, turn: action.turn };
    case SET_STARTED:
      return { ...state, started: action.started, whoStarted: state.turn };
    case SET_OPTIONS:
      return { ...state, options: action.options || {} };
    case SET_OPTION:
      let options = state.options || {};
      options = { ...options, [action.payload.name]: action.payload.value };
      dbset(OPTIONS_KEY, options);
      return { ...state, options };
    case SET_COLOR_SET:
      return { ...state, colorSet: action.index };
    default:
      return state;
  }
};

const onUpdateStats = (state, stats) => {
  if (!stats) {
    dbdel(f.statsKey(state));

    if (state.mode === MODE_SOLO) {
      stats = { plays: 0, aggScore: 0, aveScore: 0, bestScore: 0 };
    } else {
      stats = { plays: 0, aggPairs: 0, avePairs: 0, bestPairs: 0 };
    }
  } else if (state.mode === MODE_SOLO) {
    let { plays, aggScore } = stats;
    const aveScore = plays === 0 ? 0 : _.round((aggScore || 0) / plays);
    stats = { ...stats, aveScore };
  } else if (state.mode === MODE_AI) {
    let { plays, aggPairs } = stats;
    const avePairs = plays === 0 ? 0 : _.round((aggPairs || 0) / plays);
    stats = { ...stats, avePairs };
  }

  return { ...state, stats };
};
